import { IconProps } from './IconProps';

export const Cross = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="116"
      height="116"
      viewBox="0 0 116 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.6847 0C25.8542 0 0 25.8503 0 57.6808C0 89.5113 25.8542 115.35 57.6847 115.35C89.5152 115.35 115.354 89.5113 115.354 57.6808C115.354 25.8503 89.5152 0 57.6847 0ZM57.6847 3.97772C87.3655 3.97772 111.376 28 111.376 57.6808C111.376 87.3616 87.3655 111.372 57.6847 111.372C28.0039 111.372 3.9816 87.3616 3.9816 57.6808C3.9816 28 28.0039 3.97772 57.6847 3.97772Z"
        fill="#ffffff"
      />
      <path
        d="M84 84L32 32M84 32L32 84"
        stroke="#ffffff"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
};

